import React, { lazy, Suspense } from 'react';

const Map = lazy(() => import('./index.lazy'));

const renderLoader = () => <p>Loading</p>;

const MapSuspense = () => (
  <Suspense fallback={renderLoader()}>
    <Map />
  </Suspense>
);

export default MapSuspense;
